export default __webpack_public_path__ + "static/media/Blue-Android-0.85193bf3.png";